import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
const CACHE_TTL = 5 * 60 * 1000;
const MAX_BATCH_SIZE = 10;
const linkPreviewCache = new Map();
function getCached(url) {
  const entry = linkPreviewCache.get(url);
  if (!entry) return null;
  if (Date.now() - entry.timestamp > CACHE_TTL) {
    linkPreviewCache.delete(url);
    return null;
  }
  return entry.data;
}
function setCache(url, data) {
  linkPreviewCache.set(url, {
    data,
    timestamp: Date.now()
  });
}
class LinkPreviewBatchManager {
  constructor() {
    _defineProperty(this, "queue", void 0);
    _defineProperty(this, "timeout", void 0);
    _defineProperty(this, "processing", void 0);
    _defineProperty(this, "BATCH_DELAY", void 0);
    this.queue = new Map();
    this.timeout = null;
    this.processing = false;
    this.BATCH_DELAY = 50;
  }
  add(url, callback) {
    const enableBatch = app.forum.attribute('datlechin-link-preview.enableBatchRequests');
    if (!enableBatch) {
      this.fetchSingle(url, callback);
      return;
    }
    const cached = getCached(url);
    if (cached) {
      callback(cached);
      return;
    }
    if (!this.queue.has(url)) {
      this.queue.set(url, []);
    }
    this.queue.get(url).push(callback);
    this.scheduleProcessing();
  }
  scheduleProcessing() {
    if (!this.timeout) {
      this.timeout = setTimeout(() => this.process(), this.BATCH_DELAY);
    }
  }
  async fetchSingle(url, callback) {
    try {
      const response = await app.request({
        url: "".concat(app.forum.attribute('apiUrl'), "/datlechin-link-preview"),
        method: 'GET',
        params: {
          url
        }
      });
      setCache(url, response);
      callback(response);
    } catch (_unused) {
      callback({
        error: 'Failed to fetch preview'
      });
    }
  }
  async process() {
    if (this.processing || this.queue.size === 0) return;
    this.processing = true;
    this.timeout = null;
    const allUrls = Array.from(this.queue.keys());
    const allCallbacks = Array.from(this.queue.values());
    this.queue.clear();
    const urls = allUrls.slice(0, MAX_BATCH_SIZE);
    const callbacks = allCallbacks.slice(0, MAX_BATCH_SIZE);

    // Re-queue overflow
    for (let i = MAX_BATCH_SIZE; i < allUrls.length; i++) {
      this.queue.set(allUrls[i], allCallbacks[i]);
    }
    try {
      const response = await this.fetchBatch(urls);
      this.handleSuccess(response, urls, callbacks);
    } catch (_unused2) {
      this.handleError(callbacks);
    }
    this.processing = false;
    if (this.queue.size > 0) {
      this.scheduleProcessing();
    }
  }
  async fetchBatch(urls) {
    return await app.request({
      url: "".concat(app.forum.attribute('apiUrl'), "/datlechin-link-preview/batch"),
      method: 'POST',
      body: {
        urls
      }
    });
  }
  handleSuccess(response, urls, callbacks) {
    urls.forEach((url, index) => {
      var _response$url;
      const data = (_response$url = response[url]) != null ? _response$url : {
        error: 'No preview available'
      };
      setCache(url, data);
      callbacks[index].forEach(cb => cb(data));
    });
  }
  handleError(callbacks) {
    const errorData = {
      error: 'Failed to fetch preview'
    };
    callbacks.forEach(cbs => cbs.forEach(cb => cb(errorData)));
  }
}
const batchManager = new LinkPreviewBatchManager();
export default batchManager;
flarum.reg.add('datlechin-link-preview', 'forum/utils/batch-batch-manager', batchManager);